module.exports = __webpack_public_path__ + "img/instagram-icon.e385a224.svg";